<template>
  <b-card class="bg-transparent border-0">    
    <div class="row">
      <div class="col-md-11 d-flex align-items-center">        
      </div>
      <div class="col-md-1 d-flex align-items-center">
        <b-button id="btn-collapse-subtitle"
                  variant="link border-primary mt-3"
                  :title="$t('queue.caption.title')"
                  v-b-toggle.collapse-subtitle
                  v-b-tooltip
                  pill
                  style="margin-right: 8px;">
          <i class="fa fa-tags"/>
        </b-button>
        <b-button id="btn-collapse-filters"
                  variant="link border-primary mt-3"
                  :title="$t('queue.filter.title')"
                  v-b-toggle.collapse-filters
                  v-b-tooltip
                  pill>
          <i class="fas fa-search"/>
        </b-button>
        
      </div>      
    </div>
    <b-collapse id="collapse-filters" class="mt-2" v-model="filtro.show">
      <div class="row">              
        <b-form-group :label="$t('queue.filter.company')"
                      label-for="filter-company" class="col-md-3">
            <b-overlay :show="companiesLoading">
                <v-select v-model="filtro.company_filter" @input="selectCompany()" :options="companies" :reduce="option => option.value"/>
                  
            </b-overlay>
        </b-form-group>
        <b-form-group :label="$t('queue.filter.unit_care')"
                      label-for="filter-care-unit" class="col-md-3">
            <b-overlay :show="unitLoading">
                <v-select v-model="filtro.care_unit_filter" @input="selectUnitCare()" :disabled="!filtro.company_filter" :options="careunits"
                :reduce="option => option.value"/>
            </b-overlay>
        </b-form-group>
        <b-form-group :label="$t('queue.filter.sector')"
                      label-for="filter-sector" class="col-md-3">
            <b-overlay :show="sectorLoading">
                <v-select v-model="filtro.sector_filter" @input="selectSector()" :disabled="!filtro.care_unit_filter" :options="sectors" :reduce="option => option.value"/>
            </b-overlay>
        </b-form-group>
        <b-form-group label="VNS"
                      label-for="filter-vns" class="col-md-3">
            <v-select v-model="filtro.vns_filter" @input="selectVns()" :disabled="!filtro.sector_filter" :options="vnss" :reduce="option => option.value"/>
        </b-form-group>
      </div>
      <div class="row">          
        <div class="col-md-2">
          <b-btn id="btn-filter"
                  variant="primary"
                  class="align-self-center mt-3 btn-block"
                  @click="$emit('search')">
            <i class="fas fa-search"/> {{ $t('queue.filter.filter_button') }}
          </b-btn>
        </div>
        <div class="col-md-2">
          <b-btn variant="link" class="align-self-center mt-3 btn-block" @click="cleanFilters">
            <i class="fas fa-search-minus"/> {{ $t('queue.filter.clear_button') }}
          </b-btn>
        </div>
      </div>
    </b-collapse>

    <b-collapse id="collapse-subtitle" class="mt-2">
      <div class="row d-flex flex-fill">
        <b-overlay class="col-lg-12 text-center">
          <h3>{{ $t('queue.caption.service') }}</h3>
          <div class="row">
            <QueueCard
                variant="primary"
                :badge="$t('queue.caption.service_queue')"
                :name="$t('queue.caption.service_waiting')"
                class="shadow text-left"
                style="margin: auto; width: 330px;"
            />
            <QueueCard
                variant="warning"
                :badge="$t('queue.caption.realized_service')"
                :name="$t('queue.caption.report_not_send')"
                class="shadow text-left"
                style="margin: auto; width: 330px;"
            />
            <QueueCard
                variant="success"
                :badge="$t('queue.caption.realized_service')"
                :name="$t('queue.caption.report_sended')"
                class="shadow text-left"
                style="margin: auto;  width: 330px;"
            />
          </div>
        </b-overlay>      
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import {hasPerfil} from '@/acl'
import {mapActions, mapGetters} from "vuex";
import QueueCard from "@/components/QueueCard";
import Cookies from 'js-cookie';

export default {
  name: "QueueFilter",
  components: {
    QueueCard
  },
  computed: {
    ...mapGetters({
      companiesStore: 'corecompanies/all',
      companiesLoading: 'corecompanies/isLoading',
      careunitsStore: 'corecareunits/all',
      unitLoading: 'corecareunits/isLoading',
      sectorsStore: 'coresectors/all',
      sectorLoading: 'coresectors/isLoading',
      vnsStore: 'vns/all',
      vnsLoading: 'vns/isLoading',
      filtro: 'queueFilter/all'
    }),
    companies() {
      return this.companiesStore.map((company) => {
        return {
          label: company.name,
          value: company.id
        }
      })
    },
    careunits() {
      if (!this.careunitsStore) {
        return [];
      }

      return this.careunitsStore.map((careunit) => {
        return {
          label: careunit.name,
          value: careunit.id
        }
      })
    },
    sectors() {
      if (!this.sectorsStore) {
        return [];
      }

      return this.sectorsStore.map((sector) => {
        return {
          label: sector.name,
          value: sector.id
        }
      })
    },
    vnss() {
      if (!this.vnsStore) {
        return [];
      }

      return this.vnsStore.map((vns) => {
        return {
          label: vns.name,
          value: vns.id
        }
      })
    }
  },
  data() {
    return {
      isVEUS: false,
      vsCompanyId: null
    }
  },
  methods: {
    ...mapActions([
      'corecompanies/listAll',
      'coreunits/listAll',
      'coresectors/listAll',
      'vns/listAll',
      'queueFilter/setSpecific',
      'queueFilter/reset',
      'corecompanies/search',
      'corecareunits/search',
      'coresectors/search',
    ]),
    cleanFilters() {
      this['queueFilter/reset']()
      this.$emit('search')
    },
    async hasPerfil(perfil) {
      try {
        return await hasPerfil(perfil)
      } catch (e) {
        return false
      }
    },
    selectCompany() {
      this.$store.commit('queueFilter/setSpecific', {...this.filtro, ['care_unit_filter']: null})
      this.$store.commit('queueFilter/setSpecific', {...this.filtro, ['sector_filter']: null})
      this.$store.commit('queueFilter/setSpecific', {...this.filtro, ['vns_filter']: null})
      this.$store.dispatch('corecareunits/search', {filters: [['core_company_id', '=', this.filtro.company_filter]]})
      this.$emit('search')
    },
    selectUnitCare() {
      this.$store.commit('queueFilter/setSpecific', {...this.filtro, ['sector_filter']: null})
      this.$store.commit('queueFilter/setSpecific', {...this.filtro, ['vns_filter']: null})
      this.$store.dispatch('coresectors/search', {filters: [['core_care_unit_id', '=', this.filtro.care_unit_filter]]})
      this.$emit('search')
    },
    selectSector() {
      this.$store.commit('queueFilter/setSpecific', {...this.filtro, ['vns_filter']: null})      
      this.$store.dispatch('vns/listAll', {filters: [['company_id', '=', this.filtro.company_filter], ['core_care_units_id', '=', this.filtro.care_unit_filter], ['core_sector_id', '=', this.filtro.sector_filter]]})
      this.$emit('search')
    },
    selectVns() {
      this.$emit('search')
    }
  },
  async mounted() {
    this.isVEUS = await hasPerfil('root')
    this.vsCompanyId = Cookies.get('vws_veus_company_id')

    let companyFilters = [];
    if (this.isVEUS === false) {
      companyFilters = [['veus_company_id', '=', this.vsCompanyId]]
    }

    await this['corecompanies/listAll']({per_page: 500, filters: companyFilters})
  }
}
</script>

<style lang="scss" scoped>
/deep/ .mx-datepicker {
  width: 100%;
}
#collapse-filters{
  @media (max-width: 600px) {
    margin-left: 2rem!important;
    margin-right: 2rem!important;
    .ml-5, .mr-5{
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
}
</style>
